import React, {useState, useEffect, useContext, useCallback} from 'react';
import { CiFolderOn } from "react-icons/ci";

export const HFDocuments = () => {


	const files = [
			{
				name:"Öffentliche Mittel",
				description: "Unterlagen zu öffentlichen Fördermitteln – sortiert nach Bundesländern.",
				path:`/documents/cooperative`,
				files: 37
			},
			{
				name:"Eigentümer",
				description: "Unterlagen für Eigentümer – rechtliche, finanzielle und organisatorische Dokumente.",
				path:`/documents/ownerHub`,
				files: 1
			},
			{
				name:"Servicegesellschaft Genossenschaften",
				description: "Unterlagen zur Gründung und Führung einer Service-Genossenschaft – inklusive Satzung, Protokolle und organisatorischer Dokumente.",
				path:`/documents/cooperative`,
				files: 19
			},
			{
				name:"Privatkunden-Baufinanzierung",
				description: "Informationen zur Baufinanzierung für Privatkunden – Konditionen, Förderungen und Beratungshilfen.",
				path:`/documents/cooperative`,
				files: 1
			}

		]







	return (
		<div className={"mx-auto max-w-7xl orderDetails"}>
			<main>
				<div className="w-full flex">
					<div className={"text-base items-center px-6 mt-8 mb-10 leading-7 text-gray-600"}>
						<div className="mt-2 sm:flex items-center sm:justify-between">
							<div className="min-w-0 mb-4 flex flex-1">
								<h2 className="w-full text-xl truncate mb-4 Lg:ml-4 sm:mb-0 lg:text-2xl textShadow flex font-normal leading-7 text-gray-600 sm:truncate  sm:tracking-tight gap-2">
									Dokumenten Hub
								</h2>
							</div>
						</div>

						<div className={"grid-cols-3 w-full grid gap-4"}>

							{files?.map((e) => (
								<a href={e?.path}  className={" border rounded p-4 gap-4 justify-between border-gray-400 hover:border-gray-900"}>
									<CiFolderOn className={"h-12 mb-3 w-12"} />
									<div>
										<h3 className={"truncate font-bold"}>{e?.name}</h3>
										<p className={"text-gray-550 py-2 text-xs"}>{e?.description}</p>
										<p className={"text-gray-550  text-xs"}>Dokumente: {e?.files}</p>
									</div>
								</a>
							))}

						</div>
					</div>
				</div>
			</main>
		</div>
	)

}
